<template>
<div class="TestpaperMarking">
    <el-tabs v-model="activeName">
        <el-tab-pane :label="val" name="all">
            <allRead ref="allRead" @getNum="getNum"></allRead>
        </el-tab-pane>
        <el-tab-pane :label="val1" name="noSee">
            <noRead ref="noRead" @getNum1="getNum1"></noRead>
        </el-tab-pane>
        <el-tab-pane :label="val2" name="see">
            <haveRead ref="haveRead" @getNum2="getNum2"></haveRead>
        </el-tab-pane>
    </el-tabs>
</div>
</template>

<script>
import Loading from 'base/loading/loading' // 引入 loading 组件
import Page from 'base/page/page'
import allRead from 'views/operateTool/testpaper/components/allRead';
import haveRead from 'views/operateTool/testpaper/components/haveRead';
import noRead from 'views/operateTool/testpaper/components/noRead';
export default {
    name: 'TestpaperMarking',
    data() {
        return {
            activeName:'all', //选项卡默认显示
            val:'',
            val1:'',
            val2:'',
        }
    },
    mounted() {},
    methods: {
        getNum(val){
            this.val='全部'+' '+'('+val+')'
        },
        getNum1(val){
            this.val1='未批阅'+' '+'('+val+')'
        },
        getNum2(val){
            this.val2='已批阅'+' '+'('+val+')'
        },
    },
    filters: {},
    watch: {},
    components: {
        Loading,
        Page,
        allRead,
        haveRead,
        noRead
    },
    computed: {},
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">

</style>
